module.exports = __webpack_public_path__ + "media/images/products/wedding/img-hero-e5aadc88d71bd79019c5c3f7457dba16.png";